/*!
 * Roundway Quiz Products Registry
 * Hand-curated map of every recommendable SKU, with its hand-curated tag vector.
 * Tag vectors stay hand-curated (anti-hallucination rule). Handles/URLs/images
 * mirror the live Shopify product handles — refreshed from shopify-fetch
 * (35 active products, Aug 2026).
 *
 * Categories are used to pick a *different-category* stack suggestion so we
 * don't end up recommending Wormwood + Wormwood-bundle.
 *
 * Tag dictionary:
 *   gut, cleanse, reseed, liver, sleep, stress, energy, immunity,
 *   kids, recovery, hormones, skin, travel, post-cleanse, drinker,
 *   meds, daily-maintain, acute, heart, circulation, fibre, mens,
 *   womens, blood-sugar, urinary, respiratory, mood, glp1
 */
(function () {
  'use strict';
  // Image URLs below are fallbacks. The engine will upgrade them to the live
  // featured_image at runtime via /products/<handle>.js on the Shopify domain.
  var CDN = 'https://cdn.shopify.com/s/files/1/0893/9185/7991/files/';

  function P(key, handle, name, category, image, tags, blurb) {
    return [key, {
      handle: handle,
      name: name,
      category: category,
      url: '/products/' + handle,
      image: CDN + image,
      tags: tags,
      blurb: blurb,
    }];
  }

  var LIST = [
    // ---------- Cleanse / binders ----------
    P('wormwood_binder', 'wormwood-charcoal-binder', '30 Day Herbal Cleanse Protocol', 'cleanse',
      'Custom-Product-Natural-Stone-Shadow-Play.jpg?v=1770634865',
      { cleanse: 4, gut: 3, acute: 2, liver: 1, travel: 1, 'post-cleanse': -1 },
      'Wormwood plus binder, morning and night, 30 days.'),
    P('wormwood_caps', 'wormwood-black-walnut-cloves', 'Wormwood, Black Walnut & Cloves Capsules', 'cleanse',
      'Wormwood_Black_Walnut_Cloves_Capsules_60.png?v=1761255012',
      { cleanse: 4, gut: 2, acute: 2 },
      'The classic three-herb cleanse, in capsules.'),
    P('wormwood_drops', 'wormwood-black-walnut-and-clove-drops', 'Wormwood, Black Walnut & Clove Drops', 'cleanse-liquid',
      'Wormwood_Drops.png?v=1771308234',
      { cleanse: 3, gut: 2, acute: 2, travel: 1 },
      'Same three herbs, liquid, easy to dose.'),
    P('charcoal_binder', 'activated-charcoal-chlorella-spirulina-binder', 'Activated Charcoal, Chlorella & Spirulina Binder', 'binder',
      'Activated_Charcoal_capsules.png?v=1771350077',
      { cleanse: 3, 'post-cleanse': 2, gut: 2, liver: 1 },
      'The mop-up step, taken away from food.'),

    // ---------- Daily gut / probiotics ----------
    P('core_biotic', 'core-biotic', 'Core Biotic', 'daily-gut',
      'Core_Biotic_2.png?v=1786113494',
      { reseed: 3, 'post-cleanse': 3, 'daily-maintain': 3, gut: 3, immunity: 1 },
      'Ten strains plus three prebiotic fibres, daily.'),
    P('akkermansia', 'akkermansia-muciniphila-with-chicory-root-inulin-capsules-glp-1-probiotics-for-gut-health', 'Akkermansia & Inulin Capsules', 'gut-lining',
      'Akkermansia_Inulin_Capsules.png?v=1761254486',
      { glp1: 4, gut: 3, 'daily-maintain': 2, reseed: 2, 'blood-sugar': 1 },
      'Gut-lining strain with chicory root inulin.'),
    P('l_reuteri', 'lactobacillus-reuteri-capsules', 'Lactobacillus Reuteri Capsules', 'single-strain',
      'Lactobacillus_Reuteri_Capsules_0791e698-6238-47e9-9cef-90193a6f3bcc.png?v=1761253014',
      { reseed: 3, gut: 2, immunity: 2, 'daily-maintain': 1 },
      'One strain, one job, taken daily.'),
    P('colon_complex', 'colon-complex-psyllium-husk-aloe-vera-capsules', 'Colon Complex, Psyllium Husk & Aloe Vera', 'fibre',
      'Colon_Complex_Psyllium_Husk_Aloe_Vera_Capsules.png?v=1764331468',
      { fibre: 4, gut: 3, cleanse: 1, 'daily-maintain': 1 },
      'Psyllium husk and aloe for regularity.'),

    // ---------- Liver ----------
    P('milk_thistle', 'milk-thistle-with-dandelion-root-tudca-artichoke-nac-capsules', 'Milk Thistle 4-in-1', 'liver',
      'Milk_Thistle_Dandelion_TUDCA_Artichoke_NAC_Capsules.png?v=1778653821',
      { liver: 4, drinker: 3, recovery: 2, energy: 2, skin: 1, 'daily-maintain': 1 },
      'Milk thistle, dandelion root, TUDCA, artichoke, NAC.'),
    P('molybdenum', 'molybdenum-mineral-capsules', 'Molybdenum Mineral Capsules', 'mineral-trace',
      'Molybdenum_Mineral_Capsules_60.png?v=1761253752',
      { liver: 2, 'post-cleanse': 2, 'daily-maintain': 1 },
      'Trace mineral support alongside a cleanse.'),

    // ---------- Heart / circulation ----------
    P('cayenne_drops', 'cayenne-pepper-with-hawthorn-beetroot-turmeric-drops-with-vitamin-d3-k2', 'Cayenne, Hawthorn, Beetroot & Turmeric Drops', 'heart-liquid',
      'Cayenne_Pepper_Hawthorn_Beetroot_Turmeric_Drops.png?v=1785928548',
      { heart: 4, circulation: 4, energy: 2, recovery: 1 },
      'Warmth in the hands and feet, four botanicals, liquid.'),
    P('cayenne_caps', 'cayenne-pepper-hawthorn-beetroot-turmeric-capsules', 'Cayenne, Hawthorn, Beetroot & Turmeric Capsules', 'heart',
      'Cayenne_Pepper_Hawthorn_Beetroot_Tumeric_Capsules.png?v=1764331500',
      { heart: 4, circulation: 3, energy: 2, 'daily-maintain': 1 },
      'The same four botanicals, capsule form.'),
    P('beetroot_b12', 'beetroot-vitamin-b12-grape-seed-capsules', 'Beetroot, Vitamin B12 & Grape Seed', 'circulation',
      'Beetroot_Vitamin_B12_Grape_Seed_Capsules.png?v=1761253667',
      { circulation: 4, energy: 3, recovery: 3, heart: 2 },
      'Beetroot and B12 for training and stamina.'),
    P('nattokinase', 'nattokinase-bromelain-curcumin', 'Nattokinase, Bromelain & Curcumin', 'enzymes',
      'Nattokinase_Bromelain_Curcumin_Capsules_60.png?v=1761254486',
      { heart: 3, circulation: 3, recovery: 2, 'daily-maintain': 1 },
      'Enzyme blend for circulation and recovery.'),
    P('aged_garlic', 'aged-garlic-extract-capsules', 'Aged Garlic Extract Capsules', 'heart-botanical',
      'Aged_Black_Garlic_Capsules.png?v=1785928548',
      { heart: 3, immunity: 3, circulation: 2, 'daily-maintain': 1 },
      'Odourless aged garlic, daily heart and immune support.'),

    // ---------- Blood sugar / metabolic ----------
    P('berberine', 'berberine-capsules', 'Berberine Capsules', 'metabolic',
      'Berberine_Capsules.png?v=1764331292',
      { 'blood-sugar': 4, glp1: 3, gut: 1, 'daily-maintain': 1 },
      'For sugar cravings and metabolic support.'),
    P('ceylon_cinnamon', 'ceylon-cinnamon-with-cocunt-mct-oil-softgels', 'Ceylon Cinnamon with Coconut MCT', 'metabolic-softgel',
      'Ceylon_Cinnamon_with_Coconut_MCT_Oil.png?v=1785928548',
      { 'blood-sugar': 4, energy: 2, glp1: 2, 'daily-maintain': 1 },
      'True Ceylon cinnamon in MCT softgels.'),

    // ---------- Immunity / acute / respiratory ----------
    P('oregano_drops', 'wild-oil-of-oregano-drops', 'Wild Oil of Oregano Drops', 'acute',
      'Oregano_Drops.png?v=1778654017',
      { immunity: 3, gut: 2, acute: 3, travel: 4 },
      'Travel and first-sign-of-something defence.'),
    P('oregano_blackseed', 'oregano-and-black-seed-oil-capsules', 'Oregano & Black Seed Oil Capsules', 'immune-oil',
      'Oregano_and_Black_Seed_Oil_Capsules.png?v=1785928549',
      { immunity: 4, acute: 2, gut: 2, respiratory: 2, travel: 2 },
      'Two oils, one capsule, daily defence.'),
    P('black_seed_oil', 'ethiopian-black-seed-oil', 'Ethiopian Black Seed Oil', 'oil',
      'Ethiopian_Black_Seed_Oil.png?v=1785928658',
      { immunity: 3, skin: 3, 'daily-maintain': 2, respiratory: 2, hormones: 1 },
      'Cold-pressed Ethiopian black seed, taken by spoon.'),
    P('mullein', 'mullien-leaf-capsules', 'Mullein Leaf Capsules', 'respiratory',
      'Mullein_Leaf_Capsules_60.png?v=1761254486',
      { respiratory: 4, immunity: 2, acute: 1 },
      'Traditional lung and airway botanical.'),
    P('soursop', 'soursop-graviola-capsules', 'Soursop Graviola Capsules', 'botanical',
      'Soursop_Graviola_Capsules_60.png?v=1761254486',
      { immunity: 3, 'daily-maintain': 2, gut: 1 },
      'Graviola leaf, traditional daily botanical.'),

    // ---------- Sleep / stress / mood ----------
    P('magnesium_3in1', 'magnesium-glycinate-3-in-1-capsules', '3-in-1 Magnesium Glycinate', 'mineral',
      'Magnesium_d3046741-e9b2-45b1-a0ce-d98c858271af.png?v=1778653822',
      { sleep: 4, stress: 3, recovery: 2, 'daily-maintain': 2 },
      'Glycinate, malate, taurate. Evening wind-down.'),
    P('valerian_caps', 'valerian-root-capsules', 'Valerian Root Capsules', 'sleep-botanical',
      'Valerian_Root_Capsules_60.png?v=1761254486',
      { sleep: 4, stress: 3 },
      'For the nights you cannot switch off.'),
    P('valerian_drops', 'valerian-root-drops', 'Valerian Root Drops', 'sleep-liquid',
      'Valerian_Root_Drops.png?v=1771308262',
      { sleep: 4, stress: 2 },
      'Fast, flexible dosing before bed.'),
    P('saffron', 'saffron-extract-capsules', 'Saffron Extract Capsules', 'mood',
      'Saffron_Extract_Capsules_60.png?v=1761254486',
      { mood: 4, stress: 3, sleep: 1, hormones: 1 },
      'Mood and mental wellbeing, one a day.'),

    // ---------- Men's / women's / urinary ----------
    P('pumpkin_pygeum', 'pumpkin-seed-oil-pygeum-africanum-nettle-leaf-capsules', 'Pumpkin Seed Oil, Pygeum & Nettle Leaf', 'mens',
      'Pumpkin_Seed_Oil_Pygeum_Africanum_Nettle_Leaf_Capsules_60.png?v=1761255104',
      { mens: 4, urinary: 3, 'daily-maintain': 1 },
      'Three-botanical prostate and flow blend.'),
    P('pumpkin_oil', 'pumpkin-seed-oil-soft-gels', 'Cold Pressed Pumpkin Seed Oil Softgels', 'oil-softgel',
      'Cold_Pressed_Pumpkin_Seed_Oil_Softgels.png?v=1785928549',
      { mens: 3, urinary: 2, skin: 2, 'daily-maintain': 1 },
      'Cold-pressed seed oil, zinc-rich by nature.'),
    P('pumpkin_soy', 'pumpkin-seed-and-soy-germ', 'Pumpkin Seed & Soy Germ Capsules', 'womens',
      'Pumpkin_Seed_Soy_Germ_Capsules_60.png?v=1761254486',
      { womens: 4, hormones: 3, urinary: 2 },
      'For bladder comfort and hormonal balance.'),
    P('cranberry_dmannose', 'cranberry-d-mannose-lactobacillus-blend-capsules', 'Cranberry, D-Mannose & Lactobacillus', 'urinary',
      'Cranberry_D-Mannose_Lactobacillus_Blend.png?v=1761253388',
      { urinary: 4, womens: 3, immunity: 1, reseed: 1 },
      'Urinary tract blend with a live strain.'),
    P('oyster_zinc', 'freeze-dried-oyster-powder-with-zinc-picolinate', 'Freeze-Dried Oyster Powder with Zinc', 'mineral-food',
      'Freeze-dried_Oyster_Powder_with_Zinc_Picolinate.png?v=1785928549',
      { mens: 3, immunity: 3, skin: 2, hormones: 2, recovery: 2 },
      'Whole-food zinc, plus zinc picolinate.'),

    // ---------- Methylation / hormones ----------
    P('methylfolate_caps', 'methylfolate-folic-acid', 'Methylfolate Folic Acid Capsules', 'methylation',
      'Methylfolate.png?v=1771308162',
      { hormones: 3, energy: 2, mood: 2, womens: 2, 'daily-maintain': 1 },
      'Active folate, the form your body can use.'),
    P('methylfolate_drops', 'methylfolate-folic-acid-1000mcg-drops', 'Methylfolate Folic Acid Drops', 'methylation-liquid',
      '5-MTHF_Liquid.png?v=1771308512',
      { hormones: 2, energy: 2, mood: 2, womens: 2 },
      'Liquid active folate, 1000mcg per dose.'),

    // ---------- Kids (hard-gated by the engine) ----------
    P('elderberry_kids', 'eldeberry-for-kids-drops', 'Elderberry Drops for Kids', 'kids',
      'Elderberry_for_Kids_drops.png?v=1782849874',
      { kids: 4, immunity: 3, recovery: 1 },
      'Daily defence drops for ages 1+.'),
    P('magnesium_kids', 'magnesium-for-kids-drops', 'Magnesium for Kids Drops', 'kids',
      'Magnesium_for_kids_Drops.png?v=1771308572',
      { kids: 4, sleep: 3, stress: 2 },
      'Evening calm drops for ages 1+.'),
  ];

  window.RoundwayQuizProducts = {};
  LIST.forEach(function (row) { window.RoundwayQuizProducts[row[0]] = row[1]; });

  // PDP handle → product key (used to skip Q1 and seed tags).
  window.RoundwayQuizHandleMap = {};
  LIST.forEach(function (row) { window.RoundwayQuizHandleMap[row[1].handle] = row[0]; });
  // Legacy / alternate handles kept pointing at the right key.
  var ALIASES = {
    'milk-thistle-4-in-1': 'milk_thistle',
    '3-in-1-magnesium-glycinate': 'magnesium_3in1',
    'elderberry-for-kids-drops': 'elderberry_kids',
    'oregano-oil': 'oregano_drops',
    'cleanse-bundle': 'wormwood_binder',
    'wormwood-black-walnut-cloves-capsules': 'wormwood_caps',
    'aquafibre-with-electrolytes': 'colon_complex',
  };
  Object.keys(ALIASES).forEach(function (h) { window.RoundwayQuizHandleMap[h] = ALIASES[h]; });

  // Lazy resolver: upgrade fallback images to live featured_image via Shopify storefront.
  // Runs on theme + previews. Hits the live storefront cross-origin when not on the Shopify domain.
  window.RoundwayResolveProductImages = function () {
    if (typeof window.fetch !== 'function') return;
    var onShopify = !!window.Shopify || location.hostname.indexOf('myshopify') >= 0 || location.hostname.indexOf('roundway') >= 0;
    var base = onShopify ? '' : 'https://roundwaysupplements.com';
    Object.keys(window.RoundwayQuizProducts).forEach(function (key) {
      var p = window.RoundwayQuizProducts[key];
      if (!p || !p.handle) return;
      fetch(base + '/products/' + p.handle + '.js', onShopify ? { credentials: 'same-origin' } : {})
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j) return;
          // Prefer the product's main (first) image, not just featured_image which can be a lifestyle/bundle shot.
          var img = (j.images && j.images[0]) || j.featured_image;
          if (img) p.image = String(img).replace(/^\/\//, 'https://');
        })
        .catch(function () {});
    });
  };
  try { window.RoundwayResolveProductImages(); } catch (e) {}
})();
